var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0312 2.5L9.1875 2.5L8.25781 1.29688C8.03906 0.996094 7.57422 0.75 7.21875 0.75L5.03125 0.75C4.64844 0.75 4.18359 0.996094 3.96484 1.29688L3.0625 2.5L0.21875 2.5C0.0820312 2.5 0 2.60938 0 2.71875L0 3.15625C0 3.29297 0.0820312 3.375 0.21875 3.375L0.710937 3.375L1.64062 13.5742C1.69531 14.2305 2.26953 14.75 2.92578 14.75L9.29687 14.75C9.95312 14.75 10.5273 14.2305 10.582 13.5742L11.5117 3.375L12.0312 3.375C12.1406 3.375 12.25 3.29297 12.25 3.15625V2.71875C12.25 2.60938 12.1406 2.5 12.0312 2.5ZM4.67578 1.81641C4.73047 1.70703 4.89453 1.65234 5.03125 1.625L7.21875 1.625C7.32812 1.65234 7.49219 1.70703 7.54688 1.81641L8.09375 2.5L4.15625 2.5L4.67578 1.81641ZM9.73437 13.4922C9.70703 13.7109 9.51562 13.875 9.29687 13.875L2.92578 13.875C2.70703 13.875 2.51562 13.7109 2.51562 13.4922L1.61328 3.375L10.6367 3.375L9.73437 13.4922Z",
    fill: "#06A3ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.d63c8e0eb798630787ad44597be164dd.svg";
export { ForwardRef as ReactComponent };